import { render, staticRenderFns } from "./FeaturedSuppliers.vue?vue&type=template&id=7ab9e715&scoped=true&"
import script from "./FeaturedSuppliers.vue?vue&type=script&lang=js&"
export * from "./FeaturedSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab9e715",
  null
  
)

export default component.exports